import { render, staticRenderFns } from "./AppSider.vue?vue&type=template&id=2a3ceef2&scoped=true&"
import script from "./AppSider.vue?vue&type=script&lang=js&"
export * from "./AppSider.vue?vue&type=script&lang=js&"
import style0 from "./AppSider.vue?vue&type=style&index=0&id=2a3ceef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ceef2",
  null
  
)

export default component.exports